// Libs
import { TFunction } from 'i18next';
import * as yup from 'yup';
// Others
import { EMPTY_STRING } from '~/utils/constants/common';
import { ICloneProduct } from '~/utils/interface/inventory';

export const schema = (t: TFunction): yup.ObjectSchema<ICloneProduct> => {
  return yup.object().shape({
    inventoryId: yup.string().optional(),
    name: yup.string().required(t('common_validate_field_required', { ns: 'common/base' })),
    isKeepAddOn: yup.boolean().required(t('common_validate_field_required', { ns: 'common/base' })),
  });
};

export const defaultValues: ICloneProduct = {
  name: EMPTY_STRING,
  isKeepAddOn: true,
};
